import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Grid, Segment } from 'semantic-ui-react';
import FormField from '../formField';
import {useSelector} from "react-redux";
import {columnsCardTypesConfigSelector} from "../../../../ducks/representations";
import {INCIDENTS_GRID} from "../../../../constants/grids";

const Information = ({ form = {}, onChange, settings, error }) => {
    const { t } = useTranslation();

    const columnsConfig = useSelector(state => columnsCardTypesConfigSelector(state, INCIDENTS_GRID));

    const handleChangeIncidentWarehouseId = useCallback((e, { name, value }) => {
        onChange(e, { name, value });
        onChange(e, { name: 'incidentAddress', value: value && value.address ? value.address : '' });
    }, []);

    const renderField = (name, columnWidth, params = {}) => {
        if (settings && settings[name] === "hidden") {
            return null;
        }

        return (
            <Grid.Column width={columnWidth}>
                {
                    React.cloneElement(
                        <FormField
                            name={name}
                            columnsConfig={columnsConfig}
                            settings={settings}
                            form={form}
                            error={error}
                            onChange={onChange}
                        />, 
                        { ...params }
                    )}
            </Grid.Column>
        );
    };

    return (
        <Form className="tabs-card">
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <Form.Field>
                            <label>{t('general info')}</label>
                            <Segment>
                                <Grid>
                                    <Grid.Row className="field-row">
                                        {form.id && renderField("incidentNumber", 4)}
                                        {!form.isCarrierUser && renderField("carrierId", 4)}
                                        {!form.isCarrierUser && renderField("type", 4)}
                                        {renderField("category", 4)}
                                        {renderField("incidentShippingId", 4)}
                                        {renderField("incidentOrderId", 4)}
                                        {renderField("incidentWarehouseId", 4, { onChange: handleChangeIncidentWarehouseId })}
                                        {renderField("incidentAddress", 12)}
                                    </Grid.Row>
                                </Grid>
                            </Segment>
                        </Form.Field>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <Form.Field>
                            <label>{t('cost')}</label>
                            <Segment>
                                <Grid>
                                    <Grid.Row className="field-row">
                                       {renderField("declaredIncidentCost", 4, { isReadOnly: form.cannotEditDeclaredIncidentCost })}
                                       {form.id && renderField("approvedIncidentCost", 4, { isReadOnly: form.isCarrierUser } )}
                                       {form.id && !form.isCarrierUser && renderField("calculatedIncidentCost", 4)}
                                    </Grid.Row>
                                </Grid>
                            </Segment>
                        </Form.Field>
                    </Grid.Column>
                </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                        <Form.Field>
                            <label>{t('incidents.DowntimeHours')}</label>
                            <Segment>
                                <Grid>
                                    <Grid.Row className="field-row">
                                        {renderField("declaredDowntimeHours", 4)}
                                        {form.id && renderField("approvedDowntimeHours", 4, { isReadOnly: form.isCarrierUser })}
                                        {form.id && !form.isCarrierUser && renderField("calculatedDowntimeHours", 4)}
                                    </Grid.Row>
                                </Grid>
                            </Segment>
                        </Form.Field>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <Form.Field>
                            <label>{t('additionalParamets')}</label>
                            <Segment>
                                <Grid columns={2}>
                                    <Grid.Row className="field-row">
                                        <Grid.Column>
                                            {renderField("comment", 16)}
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Grid columns={2}>
                                                <Grid.Column>
                                                    {renderField("declaredArrivalDateTime", 16)}
                                                </Grid.Column>
                                                <Grid.Column>
                                                    {renderField("declaredDepartureDateTime", 16)}
                                                </Grid.Column>
                                            </Grid>
                                            {form.id && !form.isCarrierUser && (
                                                <Grid columns={2}>
                                                    <Grid.Column>
                                                        {renderField("calculatedArrivalDateTime", 16)}
                                                    </Grid.Column>
                                                    <Grid.Column>
                                                        {renderField("calculatedDepartureDateTime", 16)}
                                                    </Grid.Column>
                                                </Grid>
                                            )}
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Segment>
                        </Form.Field>
                    </Grid.Column>
                </Grid.Row>
                {form.id && (
                    <Grid.Row>
                        <Grid.Column>
                            <Form.Field>
                                <label>{t('relatedData')}</label>
                                <Segment>
                                    <Grid columns={3}>
                                        <Grid.Row className="field-row">
                                            <Grid.Column>
                                            {renderField("claimNumber", 4)}                                            
                                            {renderField("claimState", 4)}
                                            </Grid.Column>
                                            <Grid.Column>
                                            {renderField("shippingCost", 4)}
                                            {renderField("shippingState", 4)}                                            
                                            </Grid.Column>
                                            <Grid.Column>
                                            {renderField("orders", 4)}
                                            {renderField("paymentOrder", 4)}
                                            </Grid.Column>
                                        </Grid.Row>
                                        </Grid>
                                         <Grid columns={2}>
                                        <Grid.Row className="field-row">
                                            <Grid.Column>
                                            {renderField("shippingWarehouseName", 16)}
                                            </Grid.Column>
                                            <Grid.Column>
                                            {renderField("deliveryWarehouseName", 16)}
                                            </Grid.Column>
                                        </Grid.Row>                                        
                                    </Grid>
                                </Segment>
                            </Form.Field>
                        </Grid.Column>
                    </Grid.Row>
                )}
            </Grid>
        </Form>
    );
};

export default Information;
